import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import MainStore from '@src/pages/main/store';
import Page from '../../components/page';

import cx from 'classnames';

import { detectDevice } from '@src/utils/common-util';

let styles = '';
const deviceType = detectDevice();
if (deviceType === 'pc') {
  styles = require('./index.less');
} else {
  styles = require('./mo.less');
}

const Main = () => {
  /**
   * store
   * @type {MainStore}
   */
  const store = useStore(() => new MainStore());
  return (
    <Page className={cx(styles.root, 'page-main')}>
      <div className={styles.container}>
        <h2 className={cx(styles.title)}>{store?.article_title}</h2>
        <div className={styles.content} dangerouslySetInnerHTML={{ __html: store?.content }} />
      </div>
    </Page>
  );
};

export default observer(Main);
